
import { call, put, takeEvery } from "redux-saga/effects"

import { GET_SYSTEM_SETTINGS, UPDATE_SYSTEM_SETTINGS } from "./actionTypes"
import {
    getSystemSettingsSuccess,
    getSystemSettingsFail,
    updateSystemSettingsSuccess,
    updateSystemSettingsFail
} from "./actions"
import { getSystemSettings, updateSystemSettings } from "../../helpers/fakebackend_helper"

function* fetchSystemSettings() {
    try {
        const response = yield call(getSystemSettings)
        yield put(getSystemSettingsSuccess(response))
    } catch (error) {
        yield put(getSystemSettingsFail(error))
    }
}

function* onUpdateSystemSettings({ payload: settings }) {
    try {
        const response = yield call(updateSystemSettings, settings)
        yield put(updateSystemSettingsSuccess(response))
        // Refresh settings after update
        const refreshResponse = yield call(getSystemSettings)
        yield put(getSystemSettingsSuccess(refreshResponse))
    } catch (error) {
        yield put(updateSystemSettingsFail(error))
    }
}

function* settingsAdminSaga() {
    yield takeEvery(GET_SYSTEM_SETTINGS, fetchSystemSettings)
    yield takeEvery(UPDATE_SYSTEM_SETTINGS, onUpdateSystemSettings)
}

export default settingsAdminSaga
